import { render } from "./MypageFavorite.vue?vue&type=template&id=e4d41ee4"
import script from "./MypageFavorite.vue?vue&type=script&lang=js"
export * from "./MypageFavorite.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__